import React from "react";
import styles from "./AboutMeComponent.module.css";

const AboutMeComponent = () => {
  return (
    <section className={styles.about}>
      <div className={styles.container}>
        <h2 className={styles.title}>Meet Your Business Systems Partner</h2>
        <p className={styles.description}>
          I’m Daniel Rangel — a developer turned business solution architect who helps small businesses break free from bottlenecks. I don’t just write code — I design smarter workflows, custom CRMs, and scalable systems that give owners their time back.
        </p>
        <p className={styles.description}>
          With a background in full-stack development and Salesforce automation, I bridge the gap between business needs and technical execution. I’ve worked side-by-side with entrepreneurs, shop owners, and leadership teams to turn chaos into clarity through systems that just work.
        </p>
        <p className={styles.description}>
          Whether you're buried in spreadsheets, losing leads, or drowning in repetitive tasks, I build tools that fix the root problem — not just the symptoms. No jargon. No fluff. Just real solutions that grow with your business.
        </p>
      </div>
    </section>
  );
};

export default AboutMeComponent;
